export default __webpack_public_path__ + "static/media/feature3.ba36b422.jpg";